"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useWaveNotificationsReadMarkerState as useWaveNotificationsReadMarkerStateFromConfig, type MarkWaveNotificationsReadResult, type MarkWaveNotificationsReadOptions, type WaveNotificationsReadMarkerState } from "@/hooks/useMarkWaveNotificationsRead.helpers";
import { getAuthJwt } from "@/services/auth/auth.utils";
import { useContext } from "react";
export function useWaveNotificationsReadMarkerState() {
  const $ = _c(7);
  const {
    invalidateNotifications
  } = useContext(ReactQueryWrapperContext);
  const {
    address
  } = useSeizeConnectContext();
  const {
    activeProfileProxy,
    connectedProfile
  } = useAuth();
  const activeProfileProxyId = activeProfileProxy?.id ?? null;
  const activeProfileProxyCreatorId = activeProfileProxy ? activeProfileProxy.created_by.id : null;
  const connectedProfileId = connectedProfile?.id ?? null;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getAuthJwt();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== activeProfileProxyCreatorId || $[2] !== activeProfileProxyId || $[3] !== address || $[4] !== connectedProfileId || $[5] !== invalidateNotifications) {
    t1 = {
      address,
      connectedProfileId,
      activeProfileProxyId,
      activeProfileProxyCreatorId,
      walletAuth: t0,
      invalidateNotifications
    };
    $[1] = activeProfileProxyCreatorId;
    $[2] = activeProfileProxyId;
    $[3] = address;
    $[4] = connectedProfileId;
    $[5] = invalidateNotifications;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return useWaveNotificationsReadMarkerStateFromConfig(t1);
}
export function useMarkWaveNotificationsRead() {
  return useWaveNotificationsReadMarkerState().markWaveNotificationsRead;
}